var products_list = {};
var products_sort = 'best-selling';
/* Render HTML */
function uci_render_products( sort, page ){
    const $box_filter = $('.box_results_pagination .box_filter');
    const $box_results = $('.box_results_pagination .box_results');
    const $box_pagination = $('.box_results_pagination .box_pagination');

    
    if( $box_filter.length && $box_results.length && $box_pagination.length ){
        const $products_sort = uci_sort_product(products_list, sort);
        const $show_number = 20;
        const pages = Math.ceil($products_sort.length / $show_number);
        page = parseInt(page);
        
        const $show_number_start = (page - 1)*$show_number;
        
        let $show_number_end = page * $show_number;
        if( $show_number_end > $products_sort.length ){
            $show_number_end = $products_sort.length;
        }

        /**  box_filter string*/
        const $box_filter_box_page = ($show_number_start + 1) + '件 ～ ' + $show_number_end + '件 (全' + $products_sort.length + '件)';
        $box_filter.find('.box_page').html( $box_filter_box_page );

        /** box_results */
        const $products_sort_page = $products_sort.slice($show_number_start, $show_number_end);
        let $products_sort_page_html = '';
        if( $products_sort_page.length ){
            for(var i = 0; i< $products_sort_page.length; i++){
                $products_sort_page_html += uci_render_products_item( $products_sort_page[i] );
            }
        }
        $box_results.html($products_sort_page_html);

        /** Pagination */
        let $pagination_html = '';
        if( page > 1){
            $pagination_html += '<a data-page="' + ( page - 1 ) + '" href="' + window.location.href + '" class="prev">Prev</a>';
        }

        if( pages > 1 ){
            for(var i = 1; i <= pages; i++ ){
                if( i == page ){
                    $pagination_html += '<span class="current">' + i + '</span>';
                }else{
                    $pagination_html += '<a data-page="' + i + '" href="' + window.location.href + '">' + i + '</a>';
                }
            }
        }

        if( page < pages ){
            $pagination_html += '<a data-page="' + ( page + 1 ) + '" href="' + window.location.href + '" class="next">Next</a>';
        }
        $box_pagination.html($pagination_html);
    }
}

function uci_render_products_item( product ){
    let result = '<li>';
        result += '<a href="/products/' + product.handle + '" class="over">';
            result += '<p class="photo">';
                result += '<img src="' + product.image + '" alt="' + uci_escape_html(product.title) + '" width="200" height="200">';
                if( product.new ){
                    result += '<span>NEW</span>';
                }
                if( !product.available ){
                    result += '<span class="outofstock">売り切れ</span>';
                }
            result += '</p>';
            result += '<div class="info">';
                result += '<h3>' + uci_escape_html(product.title) + '</h3>';
                result += '<p class="price">';
                    let price_min = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(product.price)
                    result += '<span class="txt1">' + price_min + '</span>';
                    result += '<span class="txt2">(税込)</span>';
                result += '</p>';
            result += '</div>';
        result += '</a>';
    result += '</li>';
    return result;
}

function uci_escape_html(str){
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function uci_sort_product(product, sort){

    const available = [...product.available];
    const unavailable = [...product.unavailable];

    const sortFunc = (a,b)=>{

        switch(sort){

            case 'recommend':
                return b.recommend - a.recommend;

            case 'price-ascending':
                return a.price - b.price;

            case 'price-descending':
                return b.price - a.price;

            case 'best-selling':
            default:
                return 0;
        }
    };

    available.sort(sortFunc);
    unavailable.sort(sortFunc);

    return [
        ...available,
        ...unavailable
    ];
}

function uci_generate_list_products( products ){
    let $available = [];
    let $unavailable = [];
    if( products.length ){
        for(var i = 0; i < products.length; i++){
            $temp_product = uci_generate_list_product( products[i] );
            if( $temp_product.available ){
                $available.push($temp_product);
            }else{
                $unavailable.push($temp_product);
            }
        }
    }
    return {
        'available' : $available,
        'unavailable' : $unavailable
    };
}

function uci_generate_list_product( product ){
    return {
        'id': product.id,
        'title': product.title,
        'handle': product.handle,
        'recommend': uci_product_recommend(product),
        'price': uci_product_min_price(product),
        'image': uci_product_image(product),
        'available': uci_product_available(product),
        'new': uci_product_new(product),
    };
}

/* Check product available */
function uci_product_available( product ){
    let $result =  false;
    if( product.variants.length ){
        for(var i = 0; i < product.variants.length; i++){
            if( product.variants[i].available ){
                $result =  true;
            }
        }
    }
    return $result;
}

/** get list recommend_ids */
function uci_recommend_ids(){
    let $result = [];
    let $box_results_pagination = $('.box_results_pagination');
    if( $box_results_pagination.length ){
        $result = $box_results_pagination.attr('data-recommend-ids').split(',').filter(Boolean).map(Number);
    }
    return $result;
}

/** Check product recommend */
function uci_product_recommend( product ){
    let $result =  false;
    if( uci_recommend_ids().indexOf( product.id ) >= 0 ){
        $result =  true;
    }
    return $result;
}

/** Product price */
function uci_product_min_price( product ){
    let $result = 0;
    if( product.variants.length ){
        $result = parseFloat(product.variants[0].price);
        for(var i = 0; i < product.variants.length; i++){
            $temp_price = parseFloat(product.variants[i].price);
            if( $temp_price < $result ){
                $result = $temp_price;
            }
        }
    }
    return $result;
}

/** Product image */
function uci_product_image( product ){
    let $result = '';
    let resize = '&width=200&height=200';
    if( product.images.length ){
        $result = product.images[0].src + resize;
    }
    return $result;
}

/** Product NEW */
function uci_product_new( product ){
    let $result = false;
    if( product.tags.length && product.tags.indexOf('NEW') >= 0 ){
        // Check published_at
        if (product.published_at) {

            const publishedDate = new Date(product.published_at);
            const now = new Date();

            // 30 ngày = 30 * 24 * 60 * 60 * 1000 milliseconds
            const diffTime = now - publishedDate;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays <= 30 && diffDays >= 0) {
                $result = true;
            }
        }
    }
    return $result;
}

$( document ).ready(function() {
    let $box_results = $('.box_results_pagination');
    if( $box_results.length  ){
        let $limited = 1000;
        let $data_handle = $box_results.attr('data-handle');
        let $data_url = $box_results.attr('data-url');
        if( $data_handle != '' &&  $data_url != '' ){
            let $ajax_url = $data_url + '/products.json?sort_by=best-selling&limit=' + $limited;
            
            fetch($ajax_url)
            .then(res => res.json())
            .then(data => {
                products_list = uci_generate_list_products( data.products );

                const params = new URLSearchParams(window.location.search);
                products_sort = params.get('sort_by') || 'best-selling';
                uci_render_products( products_sort , 1 );
            });
        }
    }

    $(document).on('click', '.box_order a', function(e){
        e.preventDefault();
        products_sort =  $(this).attr('data-sort');
        $('.box_order a').removeClass('active');
        $('.box_order a').removeClass('up');
        
        $(this).addClass('active');

        if( products_sort == 'price-ascending' ){
            $(this).attr('data-sort', 'price-descending');
            $(this).addClass('up');
        }
        if( products_sort == 'price-descending' ){
            $(this).attr('data-sort', 'price-ascending');
        }

        uci_render_products( products_sort , 1 );
    })

    $(document).on('click', '.box_results_pagination .box_pagination a', function(e){
        e.preventDefault();
        let page = $(this).attr('data-page');
        uci_render_products( products_sort , page );

        $('html, body').animate({
            scrollTop: $('.box_results_pagination').offset().top - 100
        }, 500);
    });

    $(document).on('click', '.tab_collections a', function(e){
        e.preventDefault();
        
        $('.tab_collections a').removeClass('active');
        $(this).addClass('active');

        let section_id = $(this).attr('data-section-id');
        let tab_id = $(this).attr('data-id');
        if( section_id != "" && tab_id != "" && $('.wrap_tab_collections_' + section_id).length && $('.tab_collections_item_' + tab_id ).length ){
            $('.wrap_tab_collections_' + section_id + ' .tab_collections_item').removeClass('active');
            $('.wrap_tab_collections_' + section_id + ' .tab_collections_item_' + tab_id ).addClass('active');
        }
    })
});